var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tdx-ticker-logo",class:_vm.classes},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt},on:{"error":_vm.setAltImg}})])}
var staticRenderFns = []

export { render, staticRenderFns }